function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Container } from './elements';
import { containerVariants, layoutTransition } from './animation';
import { Timer } from './helpers';
/**
 * Notification Container
 *
 * @return {jsx}
 */

var NotificationContainer = function NotificationContainer(_ref) {
  var autoDismiss = _ref.autoDismiss,
      autoDismissTimeout = _ref.autoDismissTimeout,
      Component = _ref.component,
      onDismiss = _ref.onDismiss,
      pauseOnHover = _ref.pauseOnHover,
      placement = _ref.placement;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      timer = _useState2[0],
      setTimer = _useState2[1];
  /**
   * Start Timer
   *
   */


  var startTimer = useCallback(function () {
    if (!autoDismiss) return;
    setTimer(new Timer(onDismiss, autoDismissTimeout));
  }, [autoDismiss, autoDismissTimeout, onDismiss]);
  /**
   * Reset current timer with new autoDismissTimeout value
   *
   */

  var resetTimer = useCallback(function () {
    timer.resetTimer(autoDismissTimeout);
  }, [autoDismissTimeout, timer]);
  /**
   * Clear Timer
   *
   */

  var clearTimer = useCallback(function () {
    timer.clear();
  }, [timer]);
  /**
   * onMouseEnter
   *
   */

  var onMouseEnter = function onMouseEnter() {
    timer.pause();
  };
  /**
   * onMouseLeave
   *
   */


  var onMouseLeave = function onMouseLeave() {
    timer.resume();
  };
  /**
   * useEffect
   *
   */


  useEffect(function () {
    if (!timer) startTimer();
    return function () {
      if (timer) clearTimer();
    };
  }, [timer, autoDismiss, startTimer, clearTimer]);
  /**
   * useEffect to handle Component update
   *
   */

  useEffect(function () {
    // try to add time to current timer if exists (on Component change).
    if (timer) resetTimer();
  }, [Component, resetTimer, timer]);
  var hasMouseEvents = pauseOnHover && autoDismiss; // NOTE: conditions here so methods can be clean

  var handleMouseEnter = hasMouseEvents ? onMouseEnter : null;
  var handleMouseLeave = hasMouseEvents ? onMouseLeave : null;
  return /*#__PURE__*/React.createElement(Container, {
    initial: "hidden",
    animate: "visible",
    exit: "hidden",
    variants: containerVariants,
    custom: placement,
    layoutTransition: layoutTransition,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    "data-testid": "notification-container",
    role: "alert"
  }, /*#__PURE__*/React.createElement(Component, {
    onClose: onDismiss
  }));
};
/**
 * PropTypes Validation
 */


var bool = PropTypes.bool,
    func = PropTypes.func,
    number = PropTypes.number,
    string = PropTypes.string;
NotificationContainer.propTypes = {
  /**
   * Whether or not to dismiss the notification automatically after a timeout
   */
  autoDismiss: bool.isRequired,

  /**
   * The time until a notification is automatically dismissed, in milliseconds
   */
  autoDismissTimeout: number.isRequired,

  /**
   * Presentational component for displaying message
   */
  component: func.isRequired,

  /**
   * Callback function to call when notification is dismissed
   */
  onDismiss: func.isRequired,

  /**
   * Whether or not to pause the timeout when hovered
   */
  pauseOnHover: bool.isRequired,

  /**
   * Placement of the notification on the screen
   */
  placement: string.isRequired
};
NotificationContainer.displayName = 'NotificationContainer';
export default NotificationContainer;